<template>
    <div
        class="notification-toast"
        ref="toast"
        draggable="true"
        @touchstart="onTouchStart"
        @touchmove.prevent="onTouchMove"
        @touchend="e => onTouchEnd(e, notificationId)"
    >
        <div class="toast-message">{{notification.message}}</div>
        <div class="close-button" @click.prevent="onClose(notificationId)"></div>
    </div>
</template>

<script>
export default {
    name: 'Toast',
    data() {
        return {
            leftX: null,
            leftOffset: null,
            overallMovement: null
        }
    },
    props: {
        notificationId: { type: String },
        notification: { type: Object }
    },
    mounted() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    },
    destroyed() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    },
    methods: {
        onTouchStart(e) {
            this.leftX = e.currentTarget.offsetLeft;
            const touches = e.targetTouches;
            this.leftOffset = touches[0].clientX - this.leftX;
        },
        onTouchMove(e) {
            const touches = e.targetTouches;
            const leftMovement = touches[0].clientX - this.leftOffset;

            e.currentTarget.style.left = `${leftMovement}px`;
            this.overallMovement = Math.abs(leftMovement - this.leftX);

            e.currentTarget.style.opacity = `${1 - (this.overallMovement / (this.$refs.toast.offsetWidth / 100)) / 100}`;
        },
        onTouchEnd(e, notificationId) {
            if (this.overallMovement < this.$refs.toast.offsetWidth / 2) {
                e.currentTarget.style.left = `${this.leftX}px`;
                e.currentTarget.style.opacity = '1';
            } else {
                this.onClose(notificationId)
            }
        },
        onClose(notificationId) {
            this.$emit('onClose', notificationId)
        },
        handleWindowSizeChange() {
            this.$refs.toast.style.left = '';
        }
    }
}
</script>
